import { useState } from "react";
import { FiExternalLink, FiPlay } from "react-icons/fi";

/**
 * Embeds a project's live web build inside a phone frame.
 * The iframe loads on demand so the case-study page stays fast.
 *
 * @component
 * @param {object} project - A project with a `demo` URL.
 */

const LiveDemo = ({ project }) => {
  const [started, setStarted] = useState(false);

  return (
    <figure className="liveDemo">
      <div className="phoneFrame">
        <span className="phoneIsland" aria-hidden="true" />
        {started ? (
          <iframe
            src={project.demo}
            title={`${project.title} — live demo`}
            allow="microphone"
            loading="lazy"
          />
        ) : (
          <button type="button" className="demoPoster" onClick={() => setStarted(true)}>
            <img src={project.image} alt={`${project.title} — ${project.description}`} />
            <span className="demoPlay">
              <FiPlay aria-hidden="true" /> Try it live
            </span>
          </button>
        )}
      </div>
      <figcaption>
        {started ? "Tap the mic, try an example or type a note." : "Runs right here — no install needed."}{" "}
        <a href={project.demo} target="_blank" rel="noopener noreferrer">
          Open full screen <FiExternalLink aria-hidden="true" />
        </a>
      </figcaption>
    </figure>
  );
};

export default LiveDemo;
